export default __webpack_public_path__ + "static/media/active-members.5dbb444f.webp";